import templateStr from 'text!./cp-confirmation.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr
    };
}];
